var module = angular.module('octopusApp.shared');
var xss = require('xss');

module.factory('scopeValuesToScopeOptionsConverter', function() {
    return function(scopeValues){
        var optionConverter = function (r) {
            return {id: r.Id, name: xss(r.Name)};
        };
        var scopeOptions = [];
        scopeOptions.push({
            title: "Environments",
            name: "environments",
            values: _.map(scopeValues.Environments, optionConverter)
        });
        scopeOptions.push({
            title: "Roles",
            name: "roles",
            values: _.map(scopeValues.Roles, optionConverter)
        });
        scopeOptions.push({
            title: "Deployment Targets",
            name: "machines",
            values: _.map(scopeValues.Machines, optionConverter)
        });
        scopeOptions.push({
            title: "Steps",
            name: "steps",
            values: _.map(scopeValues.Actions, optionConverter)
        });
        if (scopeValues.Channels && scopeValues.Channels.length > 1) {
            scopeOptions.push({
                title: "Channels",
                name: "channels",
                values: _.map(scopeValues.Channels, optionConverter)
            });
        }
        scopeOptions.push({
            title: "TenantTags",
            name: "tenantTags",
            values: _.map(scopeValues.TenantTags, optionConverter)
        });

        return scopeOptions;
    };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/services/scope_values_to_scope_options_converter.js
// module id = 8012083844345451
// module chunks = 1